import RemoteCommands from './container/RemoteCommands'

// Sync route definition
export default {
  path: '/developer/remotecommands',
  component: RemoteCommands,
}
